import React from "react";
import "./button.scss";

interface ButtonProps {
  label: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  children?: any;
}
const Button: React.FC<ButtonProps> = ({
  label,
  className = "",
  onClick,
  disabled,
}) => {
  return (
    <button
      className={`buttonClass ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;
